export const GAME_TYPES = {
  VIRTUAL_BET: {
    listUrl: '/igames/vg/list',
    detailUrl: '/igames/vg/get',
    remainingUrl: null,
    listKey: 'virtualGames',
    title: 'Sanal Bahis',
    seoKey: 'description_seo_virtual_games',
    path: 'sanal-bahis',
    mixpanelEvent: {
      detailView: 'View Virtual Game',
      listView: 'View Virtual Games',
      gameClick: 'Click Virtual Game',
      tabClick: 'Click Category Tab Virtual Games',
      bannerClick: 'Click Banner View Page Virtual Games',
      search: 'Search Virtual Games Page Search'
    },
    showHeaderBalance: true,
    ticketButtonPath: null,
    hasDemo: false,
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: 'Sanal Bahis',
        path: '/sanal-bahis',
        icon: 'svgVirtualBet'
      }
    ]
  },
  CHANCE_GAMES: {
    listUrl: '/igames/dg/list',
    detailUrl: '/igames/dg/get',
    remainingUrl: '/igames/dg/remaining/get',
    listKey: 'digitalGames',
    title: 'Şans Oyunları',
    seoKey: 'description_raffle_seo_games_home',
    path: 'sans-oyunlari',
    mixpanelEvent: {
      detailView: 'View Digital Game',
      listView: 'View Digital Games',
      gameClick: 'Click Digital Game',
      tabClick: 'Click Category Tab Digital Games',
      bannerClick: 'Click Banner View Page Digital Games',
      search: 'Search Digital Games Page Search'
    },
    showHeaderBalance: false,
    ticketButtonPath: null,
    hasDemo: false,
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: ' Şans Oyunları',
        path: '/sans-oyunlari',
        icon: 'svgChanceGames'
      },
      {
        index: 3,
        name: 'Yardım',
        path: '/sans-oyunlari/yardim',
        icon: 'svgQuestionMarkBlack'
      }
    ]
  },
  SCRATCH_CARD: {
    listUrl: '/igames/sc/list',
    detailUrl: '/igames/sc/get',
    remainingUrl: null,
    listKey: 'scratchCards',
    title: 'Kazı Kazan',
    seoKey: 'description_seo_strachcard',
    path: 'kazi-kazan',
    mixpanelEvent: {
      detailView: 'View DBOX Game',
      listView: 'View DBOX Games',
      gameClick: 'Click DBOX Game',
      tabClick: 'Click Category Tab DBOX Games',
      bannerClick: 'Click Banner View Page DBOX Games',
      search: 'Search DBOX Games Page Search'
    },
    showHeaderBalance: false,
    ticketButtonPath: null,
    hasDemo: true,
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: 'Kazı Kazan',
        path: '/kazi-kazan',
        icon: 'svgScratchCard'
      }
    ]
  },
  MP: {
    listUrl: '/igames/mp/list',
    detailUrl: '/igames/mp/get',
    remainingUrl: '/igames/mp/remaining/get',
    listKey: 'games',
    title: 'Sayısal Oyunlar',
    seoKey: 'v1.seo.nationallottery',
    path: 'milli-piyango',
    mixpanelEvent: {
      detailView: 'View Lottery Game',
      listView: 'View Lottery Games',
      gameClick: 'Click Lottery Game',
      tabClick: 'Click Category Tab Lottery Games',
      bannerClick: 'Click Banner View Page Lottery Games',
      search: 'Search Lottery Games Page Search'
    },
    showHeaderBalance: true,
    ticketButtonPath: null,
    hasDemo: false,
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: 'Sayısal Oyunlar',
        path: '/milli-piyango',
        icon: 'svgMp'
      },
      {
        index: 3,
        name: 'Canlı Çekiliş İzle',
        path: '/milli-piyango/canli-cekilis-izle',
        icon: 'svgNavbarLive'
      },
      {
        index: 4,
        name: 'Biletlerim',
        path: '/milli-piyango/biletlerim',
        icon: 'svgNavbarTickets'
      }
    ]
  },
  VIRTUAL_HORSE_RACE: {
    listUrl: '/igames/vhr/list',
    detailUrl: '/igames/vhr/get',
    remainingUrl: null,
    listKey: 'virtualHorseRaces',
    title: 'Sanal Yarış',
    seoKey: 'v1.seo.virtualhorserace',
    path: 'sanal-yaris',
    mixpanelEvent: {
      detailView: 'View Virtual Horse Race Game',
      listView: 'View Virtual Horse Race Games',
      gameClick: 'Click Virtual Horse Race Game',
      tabClick: 'Click Category Tab Virtual Horse Race Games',
      bannerClick: 'Click Banner View Page Virtual Horse Race Games',
      search: 'Search Virtual Horse Race Games Page Search'
    },
    showHeaderBalance: true,
    ticketButtonPath: null,
    hasDemo: false,
    balanceVisibilityKey: 'v1.virtualhorserace.balance_visibility',
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: 'Sanal Yarış',
        path: '/sanal-yarisi',
        icon: 'svgVirtualHorseRace'
      }
    ]
  },
  INTERACTIVE_GAMES: {
    listUrl: '/igames/ig/list',
    detailUrl: '/igames/ig/get',
    listKey: 'interactiveGames',
    title: 'BasKazan',
    seoKey: 'v1.seo.tap_win',
    path: 'bas-kazan',
    mixpanelEvent: {
      detailView: 'View Interactive Game',
      listView: 'View Interactive Games',
      gameClick: 'Click Interactive Game',
      tabClick: 'Click Category Tab Interactive Games',
      bannerClick: 'Click Banner View Page Interactive Games',
      search: 'Search Interactive Games Page Search'
    },
    showHeaderBalance: false,
    ticketButtonPath: null,
    hasDemo: true,
    navbar: [
      {
        index: 1,
        cms_key: 'tab_name_santra',
        path: '/',
        icon: 'svgSantra'
      },
      {
        index: 2,
        name: 'BasKazan',
        path: '/bas-kazan',
        icon: 'svgInteractiveGame'
      }
    ]
  },
};
